import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WinningReson } from '../../../model/master/winningreson/winningReson';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WinningReasonService {
  url : string = "https://krios-growvac.azurewebsites.net/"
  constructor(private http: HttpClient) { }


  public submit(role): Observable<WinningReson[]> {
    // return this.http.post<WinningReson[]>(this.url+"api/WinningReasons/Insert", role);
    return this.http.post<WinningReson[]>(`${environment.apiUrl}/WinningReasons/Insert`, role);
  }


  public search(): Observable<any> {
    // return this.http.get<any[]>(this.url+"api/WinningReasons");
    return this.http.get<any[]>(`${environment.apiUrl}/WinningReasons`);
  }
  public update(role): Observable<WinningReson[]> {
    // return this.http.post<WinningReson[]>(this.url+"api/WinningReasons/Update", role);
    return this.http.post<WinningReson[]>(`${environment.apiUrl}/WinningReasons/Update`, role);
  }
}
